import { Pagination, useLocale } from 'shared-ui';

import { ExpandableList } from 'ui/expandableList/ExpandableList';
import { findServerToExpand } from 'helpers/findServerToExpand';
import { AppMessages } from 'i18n/messages';

import { SequencesTableContainer } from './sequencesTable/SequencesTableContainer';
import { SequencesListProps } from './SequencesList.types';

export const SequencesList = ({
  servers,
  isLoading,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  sequencesCount,
  setSequencesCount,
  sequencesTableSearchQuery,
}: SequencesListProps) => {
  const { formatMessage } = useLocale();

  return (
    <>
      <Pagination
        page={page}
        setPage={setPage}
        count={sequencesCount}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      />

      <ExpandableList
        data={servers || []}
        isLoading={isLoading}
        title={(server) => server.nazwa}
        initiallyExpandedItem={findServerToExpand(servers || [])}
        toggleItemExpansion={(expandedServer) => {
          setPage(0);
          if (!expandedServer) setSequencesCount(0);
        }}
        nothingToShowText={formatMessage({ id: AppMessages['sequences.noResults.nothingToShowText'] })}
        renderExpandableItemBody={(server, expandedServer) => (
          <SequencesTableContainer
            key={server.id}
            expandedServer={expandedServer}
            setSequencesCount={setSequencesCount}
            sequencesTableSearchQuery={sequencesTableSearchQuery}
          />
        )}
      />
    </>
  );
};
